module.exports = __webpack_public_path__ + "static/media/sch1.13e7b198.png";